/* ============================================================
   Size Variant Pills · Rebuy Smart Cart · v6
   Getmore · 14.07.26

   v6 — Se quita la deteccion de la banda de envio gratis por JS
   (tagShippingBand): confirmado por DevTools que Rebuy expone
   selectores estables y directos para ambos bloques, asi que el
   beige (#ECE8DC) se aplica solo por CSS en css-rebuy-size-pills.css
   sin necesidad de heuristica.

   v4 — Pills persistentes durante el swap + banda de envio:
   - El flicker restante ocurria porque Rebuy reconstruye su DOM
     tras el swap y los pills se reinyectaban DESPUES de liberar
     la mascara. Ahora la secuencia es: update.js -> refresh de
     Rebuy -> DOM estable -> REINYECTAR PILLS (cache de producto,
     instantaneo) -> recien entonces liberar la mascara.

   Solo la opcion Tamaño. Molienda, cantidad y properties se
   conservan. Exclusiones: suscripciones, regalos, productos
   sin opcion Tamaño.
   ============================================================ */
(function () {
  'use strict';

  var OPTION_MATCH = /tama/i;
  var SELECTOR_ITEM = '.rebuy-cart__flyout-item';
  var SELECTOR_INFO = '.rebuy-cart__flyout-item-info';
  var SELECTOR_VARIANT_TITLE = '.rebuy-cart__flyout-item-variant-title';
  var SELECTOR_PRICE = '.rebuy-cart__flyout-item-price';

  var productCache = Object.create(null);
  var swapping = false;
  var scheduled = null;

  function norm(s) {
    return (s || '').toString().trim().toLowerCase();
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formatted = parts.join('.');
    var fmt = (typeof window.moneyFormat === 'string' && window.moneyFormat) || '${{amount}}';
    return fmt
      .replace(/\{\{\s*amount[^}]*\}\}/, formatted)
      .replace(/<[^>]+>/g, '')
      .trim();
  }

  function rebuyItems() {
    try {
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.getItems === 'function') {
        return window.Rebuy.Cart.getItems() || [];
      }
    } catch (e) { /* noop */ }
    return [];
  }

  function rebuyRefresh() {
    try {
      var C = window.Rebuy && window.Rebuy.Cart;
      if (!C) return;
      if (typeof C.refresh === 'function') { C.refresh(); return; }
      if (typeof C.reload === 'function') { C.reload(); return; }
      if (typeof C.fetch === 'function') { C.fetch(); return; }
      if (typeof C.init === 'function') { C.init(); return; }
    } catch (e) { /* noop */ }
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productCache[handle];
  }

  function findItemForLine(line, items, used) {
    var handleClass = null;
    for (var c = 0; c < line.classList.length; c++) {
      if (line.classList[c].indexOf('product-') === 0) {
        handleClass = line.classList[c];
        break;
      }
    }
    if (!handleClass) return null;
    var handle = handleClass.slice('product-'.length);
    var vtEl = line.querySelector(SELECTOR_VARIANT_TITLE);
    var vt = norm(vtEl ? vtEl.textContent : '');

    for (var i = 0; i < items.length; i++) {
      if (used.indexOf(i) !== -1) continue;
      var it = items[i];
      if (norm(it.handle) !== norm(handle)) continue;
      if (vt && norm(it.variant_title) !== vt) continue;
      used.push(i);
      return it;
    }
    return null;
  }

  function isEligible(item) {
    if (!item || !item.key || !item.variant_id) return false;
    if (item.selling_plan_allocation) return false;
    if (typeof item.price === 'number' && item.price === 0) return false;
    return true;
  }

  function variantForSize(product, current, sizeIdx, sizeValue) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var o = 0; o < 3; o++) {
        var key = 'option' + (o + 1);
        var want = (o === sizeIdx) ? sizeValue : current[key];
        if ((v[key] || null) !== (want || null)) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function hasProps(obj) {
    if (!obj) return false;
    for (var k in obj) { if (Object.prototype.hasOwnProperty.call(obj, k)) return true; }
    return false;
  }

  /* --- UI optimista --- */
  function optimisticUpdate(line, wrap, item, currentSize, targetVariant, newSize) {
    var pills = wrap.querySelectorAll('.tc-size-pill');
    Array.prototype.forEach.call(pills, function (b) {
      var active = b.textContent === newSize;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
      b.disabled = active || b.classList.contains('is-unavailable');
    });

    var vt = line.querySelector(SELECTOR_VARIANT_TITLE);
    if (vt && currentSize && vt.textContent.indexOf(currentSize) !== -1) {
      vt.textContent = vt.textContent.replace(currentSize, newSize);
    }

    var priceEl = line.querySelector(SELECTOR_PRICE);
    if (priceEl && targetVariant && typeof targetVariant.price === 'number') {
      var monies = priceEl.querySelectorAll('.rebuy-money');
      var targetMoney = null;
      Array.prototype.forEach.call(monies, function (mEl) {
        if (mEl.closest('del')) return;
        if (/compare/i.test(mEl.className)) return;
        targetMoney = mEl;
      });
      if (targetMoney) {
        targetMoney.textContent = formatMoney(targetVariant.price * (item.quantity || 1));
      }
    }
  }

  /* --- Mascara: snapshot fijo del flyout --- */
  function createMask() {
    var flyout = document.querySelector('#rebuy-cart .rebuy-cart__flyout') || document.getElementById('rebuy-cart');
    if (!flyout) return null;
    var rect = flyout.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;

    var holder = document.createElement('div');
    holder.className = 'tc-swap-mask';
    holder.style.cssText = 'position:fixed;top:' + rect.top + 'px;left:' + rect.left + 'px;width:' + rect.width + 'px;height:' + rect.height + 'px;z-index:2147483000;overflow:hidden;pointer-events:auto;opacity:1;';

    var clone = flyout.cloneNode(true);
    clone.removeAttribute('id');
    var withIds = clone.querySelectorAll('[id]');
    Array.prototype.forEach.call(withIds, function (el) { el.removeAttribute('id'); });
    clone.style.margin = '0';
    clone.style.position = 'static';
    clone.style.width = '100%';
    clone.style.height = '100%';
    clone.style.transform = 'none';
    holder.appendChild(clone);
    document.body.appendChild(holder);

    var src = flyout.querySelectorAll('*');
    var dst = clone.querySelectorAll('*');
    for (var i = 0; i < src.length && i < dst.length; i++) {
      if (src[i].scrollTop) dst[i].scrollTop = src[i].scrollTop;
    }
    return holder;
  }

  function releaseMask(holder) {
    if (!holder) return;
    holder.style.opacity = '0';
    setTimeout(function () {
      if (holder.parentNode) holder.parentNode.removeChild(holder);
    }, 220);
  }

  function waitForSettle(cb) {
    var target = document.getElementById('rebuy-cart');
    if (!target) { cb(); return; }
    var quiet = null;
    var done = false;
    var obs = new MutationObserver(function () {
      if (quiet) clearTimeout(quiet);
      quiet = setTimeout(finish, 300);
    });
    var cap = setTimeout(finish, 1800);
    function finish() {
      if (done) return;
      done = true;
      obs.disconnect();
      clearTimeout(cap);
      if (quiet) clearTimeout(quiet);
      cb();
    }
    obs.observe(target, { childList: true, subtree: true, characterData: true });
    quiet = setTimeout(finish, 600);
  }

  /* --- Swap --- */
  function swapVariant(line, wrap, item, currentSize, targetVariant, newSize) {
    if (swapping) return;
    swapping = true;
    wrap.classList.add('is-syncing');

    optimisticUpdate(line, wrap, item, currentSize, targetVariant, newSize);
    var mask = createMask();

    /* Al terminar: refresh de Rebuy -> DOM estable -> reinyectar
       pills DETRAS de la mascara -> revelar. Asi los pills nunca
       desaparecen a la vista. */
    var finish = function () {
      rebuyRefresh();
      waitForSettle(function () {
        render(true).then(function () {
          window.requestAnimationFrame(function () {
            releaseMask(mask);
            swapping = false;
          });
        });
      });
    };

    var items = rebuyItems();
    var oldId = item.variant_id;
    var newId = targetVariant.id;

    var oldLines = items.filter(function (it) { return it.variant_id === oldId; });
    var targetLines = items.filter(function (it) { return it.variant_id === newId; });
    var planConflict = items.some(function (it) {
      return it.selling_plan_allocation && (it.variant_id === oldId || it.variant_id === newId);
    });
    var targetHasProps = targetLines.some(function (it) { return hasProps(it.properties); });

    var canAtomic = !hasProps(item.properties) &&
      oldLines.length === 1 &&
      targetLines.length <= 1 &&
      !targetHasProps &&
      !planConflict;

    if (canAtomic) {
      var updates = {};
      updates[String(oldId)] = 0;
      updates[String(newId)] = (item.quantity || 1) + (targetLines.length ? (targetLines[0].quantity || 0) : 0);

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(finish)
        .catch(finish);
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: newId, quantity: item.quantity || 1, properties: item.properties || {} }]
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        })
        .then(finish)
        .catch(finish);
    }
  }

  function buildPills(line, item, product) {
    var info = line.querySelector(SELECTOR_INFO);
    if (!info) return;

    var existing = info.querySelector('.tc-size-pills');
    if (existing && existing.getAttribute('data-tc-key') === item.key) return;
    if (existing) existing.remove();

    var sizeIdx = -1;
    var options = product.options || [];
    for (var i = 0; i < options.length; i++) {
      var name = typeof options[i] === 'string' ? options[i] : options[i].name;
      if (OPTION_MATCH.test(name || '')) { sizeIdx = i; break; }
    }
    if (sizeIdx === -1) return;

    var optionDef = options[sizeIdx];
    var values = (optionDef && optionDef.values) || [];
    if (values.length < 2) return;

    var current = null;
    for (var v = 0; v < product.variants.length; v++) {
      if (product.variants[v].id === item.variant_id) { current = product.variants[v]; break; }
    }
    if (!current) return;
    var currentSize = current['option' + (sizeIdx + 1)];

    var wrap = document.createElement('div');
    wrap.className = 'tc-size-pills';
    wrap.setAttribute('data-tc-key', item.key);
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Cambiar tama\u00f1o');

    values.forEach(function (value) {
      var target = variantForSize(product, current, sizeIdx, value);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tc-size-pill';
      btn.textContent = value;

      if (value === currentSize) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        btn.disabled = true;
      } else if (!target || !target.available) {
        btn.classList.add('is-unavailable');
        btn.disabled = true;
        btn.setAttribute('aria-label', value + ' agotado');
      } else {
        btn.setAttribute('aria-pressed', 'false');
        (function (tv, val) {
          btn.addEventListener('click', function () {
            swapVariant(line, wrap, item, currentSize, tv, val);
          });
        })(target, value);
      }
      wrap.appendChild(btn);
    });

    var anchor = info.querySelector(SELECTOR_VARIANT_TITLE);
    if (anchor) {
      anchor.insertAdjacentElement('afterend', wrap);
    } else {
      var titleEl = info.querySelector('.rebuy-cart__flyout-item-product-title');
      if (titleEl) titleEl.insertAdjacentElement('afterend', wrap);
      else info.appendChild(wrap);
    }
  }

  /* render devuelve una Promise que resuelve cuando todos los
     pills quedaron inyectados (clave para revelar la mascara
     solo cuando el DOM ya esta completo). */
  function render(force) {
    if (swapping && !force) return Promise.resolve();
    var cartEl = document.getElementById('rebuy-cart');
    if (!cartEl) return Promise.resolve();

    var lines = cartEl.querySelectorAll(SELECTOR_ITEM);
    if (!lines.length) return Promise.resolve();
    var items = rebuyItems();
    if (!items.length) return Promise.resolve();

    var used = [];
    var jobs = [];
    Array.prototype.forEach.call(lines, function (line) {
      var item = findItemForLine(line, items, used);
      if (!item || !isEligible(item)) return;
      jobs.push(
        fetchProduct(item.handle).then(function (product) {
          if (!product || !product.variants) return;
          if (swapping && !force) return;
          if (!document.body.contains(line)) return;
          buildPills(line, item, product);
        })
      );
    });
    return Promise.all(jobs);
  }

  function schedule() {
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(render, 150);
  }

  [
    'rebuy:cart.ready',
    'rebuy:cart.change',
    'rebuy:cart.add',
    'rebuy:cart.remove',
    'rebuy:cart.increase',
    'rebuy:cart.decrease',
    'rebuy:smartcart.ready',
    'rebuy:smartcart.show'
  ].forEach(function (evt) {
    document.addEventListener(evt, schedule);
  });

  var observer = new MutationObserver(function (mutations) {
    if (swapping) return;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      var t = m.target;
      if (t && t.closest && t.closest('.tc-size-pills')) continue;
      if (t && t.closest && t.closest('.tc-swap-mask')) continue;
      if (t && t.closest && t.closest('#rebuy-cart')) { schedule(); return; }
      for (var n = 0; n < m.addedNodes.length; n++) {
        var node = m.addedNodes[n];
        if (node.nodeType === 1 && (node.id === 'rebuy-cart' || (node.querySelector && node.querySelector('#rebuy-cart')))) {
          schedule();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState !== 'loading') {
    schedule();
  } else {
    document.addEventListener('DOMContentLoaded', schedule);
  }
})();
